/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HubTerminalTipOptions } from './HubTerminalTipOptions';
import {
    HubTerminalTipOptionsFromJSON,
    HubTerminalTipOptionsFromJSONTyped,
    HubTerminalTipOptionsToJSON,
    HubTerminalTipOptionsToJSONTyped,
} from './HubTerminalTipOptions';

/**
 * 
 * @export
 * @interface Amount
 */
export interface Amount extends HubTerminalTipOptions {
    /**
     * 
     * @type {Array<number>}
     * @memberof Amount
     */
    values: Array<number>;
}

/**
 * Check if a given object implements the Amount interface.
 */
export function instanceOfAmount(value: object): value is Amount {
    if (!('values' in value) || value['values'] === undefined) return false;
    return true;
}

export function AmountFromJSON(json: any): Amount {
    return AmountFromJSONTyped(json, false);
}

export function AmountFromJSONTyped(json: any, ignoreDiscriminator: boolean): Amount {
    if (json == null) {
        return json;
    }
    return {
        ...HubTerminalTipOptionsFromJSONTyped(json, true),
        'values': json['values'],
    };
}

export function AmountToJSON(json: any): Amount {
    return AmountToJSONTyped(json, false);
}

export function AmountToJSONTyped(value?: Amount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        ...HubTerminalTipOptionsToJSONTyped(value, true),
        'values': value['values'],
    };
}

